import React from "react";

export const MetricCard = ({ label, value, sub, icon: Icon, accent = false, testId }) => (
  <div
    data-testid={testId}
    className="cc-surface cc-card-hover rounded-2xl p-5 flex items-start justify-between gap-4"
  >
    <div>
      <div className="cc-overline">{label}</div>
      <div className={`font-mono text-2xl md:text-3xl mt-2 tracking-tight ${accent ? "text-[#00ff88]" : "text-white"}`}>{value}</div>
      {sub && <div className="text-[11px] text-[#606070] mt-1">{sub}</div>}
    </div>
    {Icon && (
      <div className="w-10 h-10 rounded-lg border border-[#15152a] bg-[#06060c] flex items-center justify-center text-[#00ff88]">
        <Icon size={18} />
      </div>
    )}
  </div>
);

export default MetricCard;
